module.exports = __webpack_public_path__ + "img/icon-scss.4e75cf43.svg";